/**
 * Chargeback-specific constants
 *
 * Entry types and stakeholder types as returned by the chargeback backend.
 * These use UPPERCASE naming (different from the general accounting constants).
 */

// Entry types (backend returns UPPERCASE)
export const ENTRY_TYPES = {
    ORDER_REVENUE: 'ORDER_REVENUE',
    ORDER_FEE: 'ORDER_FEE',
    ORDER_COST: 'ORDER_COST',
    DISPUTE_FEE: 'DISPUTE_FEE',
}

export const ENTRY_TYPE_LABELS = {
    [ENTRY_TYPES.ORDER_REVENUE]: 'Revenue',
    [ENTRY_TYPES.ORDER_FEE]: 'Fee',
    [ENTRY_TYPES.ORDER_COST]: 'Cost',
    [ENTRY_TYPES.DISPUTE_FEE]: 'Dispute Fee',
}

// Dispute statuses (from Stripe)
export const DISPUTE_STATUSES = {
    WARNING_NEEDS_RESPONSE: 'warning_needs_response',
    WARNING_UNDER_REVIEW: 'warning_under_review',
    WARNING_CLOSED: 'warning_closed',
    NEEDS_RESPONSE: 'needs_response',
    UNDER_REVIEW: 'under_review',
    WON: 'won',
    LOST: 'lost',
}

export const DISPUTE_STATUS_LABELS = {
    [DISPUTE_STATUSES.WARNING_NEEDS_RESPONSE]: 'Warning - Needs Response',
    [DISPUTE_STATUSES.WARNING_UNDER_REVIEW]: 'Warning - Under Review',
    [DISPUTE_STATUSES.WARNING_CLOSED]: 'Warning - Closed',
    [DISPUTE_STATUSES.NEEDS_RESPONSE]: 'Needs Response',
    [DISPUTE_STATUSES.UNDER_REVIEW]: 'Under Review',
    [DISPUTE_STATUSES.WON]: 'Won',
    [DISPUTE_STATUSES.LOST]: 'Lost',
}

export const DISPUTE_STATUS_COLORS = {
    [DISPUTE_STATUSES.WARNING_NEEDS_RESPONSE]: 'warning',
    [DISPUTE_STATUSES.WARNING_UNDER_REVIEW]: 'warning',
    [DISPUTE_STATUSES.WARNING_CLOSED]: 'secondary',
    [DISPUTE_STATUSES.NEEDS_RESPONSE]: 'danger',
    [DISPUTE_STATUSES.UNDER_REVIEW]: 'info',
    [DISPUTE_STATUSES.WON]: 'success',
    [DISPUTE_STATUSES.LOST]: 'danger',
}

// Stakeholder types (backend returns these values)
// TODO: Verificare nomenclatura 'photographer' — potrebbe essere 'contract_manager'
export const STAKEHOLDER_TYPES = {
    PHOTOGRAPHER: 'photographer',
    PICA: 'pica',
    ORGANIZER: 'organizer',
}

export const STAKEHOLDER_TYPE_LABELS = {
    [STAKEHOLDER_TYPES.PHOTOGRAPHER]: 'Photographer',
    [STAKEHOLDER_TYPES.PICA]: 'Pica',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'Organizer',
}

export const STAKEHOLDER_TYPE_COLORS = {
    [STAKEHOLDER_TYPES.PHOTOGRAPHER]: 'info',
    [STAKEHOLDER_TYPES.PICA]: 'primary',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'success',
}

/**
 * Normalize a chargeback entry for use with LedgerEntriesTable.
 * Maps UPPERCASE entry_type to lowercase (matching global accounting constants).
 */
export function normalizeEntry(entry) {
    return {
        ...entry,
        entry_type: entry.entry_type ? entry.entry_type.toLowerCase() : entry.entry_type,
    }
}
